import jwt_decode from "jwt-decode";
import axios from "axios";
import api from "./store/services/api";

export const decodeUserJWT = (key) => {
  const decoded = jwt_decode(key);
  return decoded.user_id;
};

export const getLabel = (key) => {
  switch (key) {
    case "Confirmação enviada":
      return "label__icon--grey";

    case "Confirmado":
      return "label__icon--green";

    case "Aguardando confirmação de despache":
      return "label__icon--grey";

    case "A caminho":
      return "label--going";

    case "Aguardando confirmação de Pronto":
      return "label__icon--grey";

    case "Pronto para retirada":
      return "label--ready";

    case "Finalizado":
      return "label--finish";

    case "Entregue":
      return "label--finish";

    case "Aguardando cancelamento aceito":
      return "label__icon--grey";

    case "Aguardando cancelamento rejeitado":
      return "label__icon--grey";

    case "Cancelado":
      return "label--cancel";

    case "Em preparo":
      return "label--start";

    default:
      return "label__icon--grey";
  }
};

export const getLabelFromStatusNumber = (status_number) => {
  switch (status_number) {
    case 1:
      return "label__icon--grey";

    case 2:
      return "label__icon--green";

    case 3:
      return "label__icon--grey";

    case 5:
      return "label--going";

    case 8:
      return "label--start";

    case 13:
      return "label__icon--grey";

    case 15:
      return "label__icon--orange";

    case 21:
      return "label--ready";

    case 34:
      return "label--finish";

    case 144:
      return "label__icon--grey";

    case 233:
      return "label__icon--grey";

    case 377:
      return "label--cancel";

    default:
      return "label__icon--grey";
  }
};

export const getTranslation = (key) => {
  switch (key) {
    case "PLC":
      return "Realizada";
    case "CFM":
      return "Aceito";
    case "RTP":
      return "Pronto";
    case "OPE":
      return "Carrinho Editado";
    case "OBA":
      return "Desconto Adicionado";
    case "OBR":
      return "Desconto Removido";
    case "DSP":
      return "Despachado";
    case "CART":
      return "Carrinho";
    case "CON":
      return "Entregue";
    case "DELIVERY_FEE":
      return "Entrega";
    case "CAR":
      return "Cancelamento Solicitado";
    case "CCR":
      return "Cancelamento Solicitado pelo Cliente";
    case "CCA":
      return "Solicitação de Cancelamento Aceita";
    case "CAN":
      return "Cancelado";
    case "PAA":
      return "Vaga informada";
    case "ITEM":
      return "Item";
    case "PROGRESSIVE_DISCOUNT_ITEM":
      return "Itens iguais do pedido";
    case "MERCHANT":
      return "Loja";
    case "IFOOD":
      return "iFood";
    case "FOOD99":
      return "99Food";

    default:
      return key;
  }
};

export const getEventCreatedByInfosString = (infos) => {
  if (!infos) return "SISTEMA";

  return `${infos.first_name || "Operador"} ${infos.last_name}`;
};

export const getCancelCodeLabel = (key) => {
  switch (key) {
    case "501":
      return "PROBLEMAS DE SISTEMA";
    case "502":
      return "PEDIDO EM DUPLICIDADE";
    case "503":
      return "ITEM INDISPONÍVEL";
    case "504":
      return "RESTAURANTE SEM MOTOBOY";
    case "505":
      return "CARDÁPIO DESATUALIZADO";
    case "506":
      return "PEDIDO FORA DA ÁREA DE ENTREGA";
    case "507":
      return "CLIENTE GOLPISTA / TROTE";
    case "508":
      return "FORA DO HORÁRIO DO DELIVERY";
    case "509":
      return "DIFICULDADES INTERNAS DO RESTAURANTE";
    case "511":
      return "ÁREA DE RISCO";
    case "512":
      return "RESTAURANTE ABRIRÁ MAIS TARDE";
    case "513":
      return "RESTAURANTE FECHOU MAIS CEDO";
    case "902":
      return "NÃO CONFIRMADO PELO RESTAURANTE";
    case "406":
      return "PEDIDO ACIDENTAL";
    default:
      break;
  }
};

function getRGB(c) {
  return parseInt(c, 16) || c;
}

function getsRGB(c) {
  return getRGB(c) / 255 <= 0.03928
    ? getRGB(c) / 255 / 12.92
    : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4);
}

function getLuminance(hexColor) {
  return (
    0.2126 * getsRGB(hexColor.substr(1, 2)) +
    0.7152 * getsRGB(hexColor.substr(3, 2)) +
    0.0722 * getsRGB(hexColor.substr(-2))
  );
}

function getContrast(f, b) {
  const L1 = getLuminance(f);
  const L2 = getLuminance(b);
  return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
}

export const getTextColorByBackgroundContrast = (bgColor) => {
  const whiteContrast = getContrast(bgColor, "#ffffff");
  const blackContrast = getContrast(bgColor, "#000000");

  return whiteContrast > blackContrast ? "#ffffff" : "#000000";
};

export const searchCep = async (cep) => {
  if (cep.length === 8) {
    const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    return data;
  }
};

export const addressCoordinates = async (
  street,
  houseNumber,
  neighborhood,
  city
) => {
  const res = await api.get(
    `/latlng?street=${street}&house_number=${houseNumber}&neighborhood=${neighborhood}&city=${city}`
  );
  const { latitude, longitude } = res.data;
  return {
    lat: latitude,
    lng: longitude,
  };
};

export const translateDiscountType = (type) => {
  switch (type) {
    case "PERCENTAGE":
      return "Porcentagem";

    case "MONEY_AMOUNT":
      return "Valor";

    case "DISCOUNT_COUPON":
      return "Cupom de Desconto";

    default:
      return type;
  }
};

export const translateOrderType = (type) => {
  switch (type) {
    case "DELIVERY":
      return "Delivery";

    case "TAKEOUT":
      return "Retirada";

    case "INDOOR":
      return "Salão";

    default:
      return type;
  }
};

export const extractNumbersFromString = (inputString) => {
  if (!inputString) return;
  return inputString.replace(/\D/g, "");
};

export const getBenefitName = (name) => {
  switch (name) {
    case "IFOOD":
      return "Ifood";
    case "EXTERNAL":
      return "Indústria";
    case "MERCHANT":
      return "Loja";

    default:
      return name;
  }
};

export const getBenefitTarget = (name) => {
  switch (name) {
    case "CART":
      return "Carrinho";
    case "DELIVERY_FEE":
      return "Taxa de entrega";
    case "ITEM":
      return "Produtos";
    case "PROGRESSIVE_DISCOUNT_ITEM":
      return "Itens iguais";

    default:
      return name;
  }
};

export const cleanSpecialCharacters = (value) => {
  if (!value) return "";
  return value.replace(/[!@#$%^&*()_+{}[\]:;<>,.?~\\/\-=]/g, " ");
};

export const fillWithSpecialCharacters = (value) => {
  if (!value) return "";
  return value.replace(/\s/g, "_");
};

export const getStartAndEndOfDay = () => {
  const now = new Date();
  const startOfDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0,
    0
  );
  const endOfDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59,
    999
  );

  // Adjust for timezone offset
  const timezoneOffset = now.getTimezoneOffset();
  startOfDay.setMinutes(startOfDay.getMinutes() - timezoneOffset);
  endOfDay.setMinutes(endOfDay.getMinutes() - timezoneOffset);

  const dateStart = startOfDay.toISOString();
  const dateEnd = endOfDay.toISOString();

  return { dateStart, dateEnd };
};

export const getWeightAdornment = (unit, value) => {
  if (unit === "KG") {
    if (value >= 1) {
      return "Kg";
    } else {
      return "g";
    }
  }

  return "";
};

export const getProductQuantityNumberOverUnit = (unit, quantity) => {
  return unit === "UN" ? Math.floor(Number(quantity)) : Number(quantity);
};

export const parseFloatToFixed = (valueToParse, fixedValue = 2) => {
  return parseFloat(parseFloat(valueToParse).toFixed(fixedValue));
};

export const sendWhatsAppMessage = (phoneString) => {
  const cleanedPhoneNumber = phoneString.replace(/\D/g, "");

  const url = `https://wa.me/+55${cleanedPhoneNumber}`;

  window.open(url, "_blank");
};
